import instance from 'utils/axios/instance.axios';
import { COUNCILS } from './_constant';

export const getAllCouncils = (pagination, filters, showMode) =>
  instance.get(COUNCILS.GET_ALL, { params: { ...pagination, ...filters, showMode } });

export const getAll = (id) => instance.get(COUNCILS.GET_ALL_BY_ID_PROJECT_PROPOSAL(id));

export const create = (body = {}) => instance.post(COUNCILS.POST_CREATE, body);

export const createForMultipleProjectProposals = (body = {}) =>
  instance.post(COUNCILS.POST_CREATE_FOR_MULTIPLE_PROJECTS, body);

export const editForMultipleProjectProposals = (body = {}) =>
  instance.patch(COUNCILS.PATCH_EDIT_FOR_MULTIPLE_PROJECTS, body);

export const getCouncilMultipleProjectsById = (id) =>
  instance.get(COUNCILS.GET_FOR_MULTIPLE_PROJECTS(id));

export const getById = ({ councilId, projectProposalId }) =>
  instance.get(COUNCILS.GET_BY_ID(councilId), { params: { projectProposalId } });

export const downloadFile = (data = {}) =>
  instance.post(COUNCILS.DOWNLOAD_FILE, data, { responseType: 'blob' });

export const downloadCouncilMemberExcelFile = (id, projectProposalId) =>
  instance.get(COUNCILS.DOWNLOAD_COUNCIL_MEMBER_EXCEL_FILE(id, projectProposalId), {
    responseType: 'blob',
  });

export const updateResult = (body = {}) => instance.patch(COUNCILS.PATCH_UPDATE_RESULT, body);

export const update = (body = {}) => instance.patch(COUNCILS.PATCH_UPDATE, body);

export const sendMailFinishMembers = (body = {}) =>
  instance.post(COUNCILS.POST_SEND_MAIL_FINISH_MEMBERS, body);

export const getAllCouncilTypes = () => instance.get(COUNCILS.GET_ALL_COUNCIL_TYPES);

export const getAllCouncilMemberRoles = () => instance.get(COUNCILS.GET_ALL_COUNCIL_MEMBER_ROLES);

export const deleteById = (id) => instance.delete(COUNCILS.DELETE_BY_ID(id));

export const sendMailRemindMembers = (body = {}) =>
  instance.post(COUNCILS.POST_SEND_MAIL_REMIND_MEMBERS, body);

export const createOrUpdatePrequalificationCouncil = (data = {}) =>
  instance.post(COUNCILS.CREATE_OR_UPDATE_PREQUALIFICATION_COUNCIL, data);

export const getPrequalificationCouncilOfProjectProposal = ({ projectProposalId }) =>
  instance.get(COUNCILS.GET_PREQUALIFICATION_COUNCIL_OF_PROJECT_PROPOSAL, {
    params: { projectProposalId },
  });
export const getSpecializationCouncilOfProjectProposal = ({ projectProposalId }) =>
  instance.get(COUNCILS.GET_SPECIALIZATION_COUNCIL_OF_PROJECT_PROPOSAL, {
    params: { projectProposalId },
  });
export const getFinanceCouncilOfProjectProposal = ({ projectProposalId }) =>
  instance.get(COUNCILS.GET_FINANCE_COUNCIL_OF_PROJECT_PROPOSAL, {
    params: { projectProposalId },
  });
export const getAcceptanceCouncilOfProjectProposal = ({ projectProposalId }) =>
  instance.get(COUNCILS.GET_ACCEPTANCE_COUNCIL_OF_PROJECT, {
    params: { projectProposalId },
  });

export const getLiquidationCouncilOfProjectProposal = ({ projectProposalId }) =>
  instance.get(COUNCILS.GET_LIQUIDATION_COUNCIL_OF_PROJECT, {
    params: { projectProposalId },
  });

export const getMidtermReportCouncilOfProject = ({ projectProposalId, summaryReportId }) =>
  instance.get(COUNCILS.GET_MIDTERN_REPORT_COUNCIL_OF_PROJECT, {
    params: { projectProposalId, summaryReportId },
  });

export const changeRequestStatus = (data = {}) =>
  instance.post(COUNCILS.POST_CHANGE_REQUEST_STATUS, data);

export const getMidternDocumentReviewById = (id) =>
  instance.get(COUNCILS.GET_MIDTERN_DOCUMENT_REVIEW(id));

export const createOrUpdateMidternDocumentReview = (data = {}) =>
  instance.post(COUNCILS.POST_MIDTERN_DOCUMENT_REVIEW, data);

export const getDetailCouncilWithMultipleProjects = ({ councilId }) =>
  instance.get(COUNCILS.GET_COUNCIL_MULTIPLE_PROJECTS_BY_ID(councilId));

export const sendMailMultipleProjects = (body = {}) =>
  instance.post(COUNCILS.POST_SEND_MAIL_MULTIPLE_PROJECT, body);

export const sendMailRemindMultipleProjects = (body = {}) =>
  instance.post(COUNCILS.POST_SEND_MAIL_REMIND_MULTIPLE_PROJECT, body);

export const sendMailToCouncilMember = (data = {}) => {
  const { memberId, councilId, ...body } = data;

  return instance.post(COUNCILS.SEND_MAIL_COUNCIL_TO_MEMBER(councilId, memberId), body);
};

export const sendMailToCouncilMemberOfMultiProjects = (data = {}) => {
  const { councilId, memberId, ...body } = data;

  return instance.post(
    COUNCILS.SEND_MAIL_COUNCIL_HAS_PROJECTS_TO_MEMBER(councilId, memberId),
    body
  );
};

export const updateMemberAttendance = (body = {}) =>
  instance.patch(COUNCILS.PATCH_UPDATE_MEMBER_ATTENDANCE, body);

export const getCouncilMailLogs = (councilId, params = {}) =>
  instance.get(COUNCILS.GET_COUNCIL_MAIL_LOGS(councilId), { params });
